export default __webpack_public_path__ + "static/media/poster.2f4843c8.png";